import React, { Component } from 'react';
import { connect } from 'react-redux'
import { CircularProgress } from '@mui/material';
import HeaderLogo from '../../images/headerLogo'
import T from 'i18n-react';
import { goBack } from 'connected-react-router';

class ErrorPage extends Component {
    constructor(props) {
        super(props);

        this.logoutType = 'normal'

        this.state = {
            lang: this.props.lang,  
            error: this.props.error,
            errorDetail: this.props.errorDetail,
            isloading: false
        }
    }

    componentWillReceiveProps(newProps) {
        if (this.state.lang !== newProps.lang) {
            this.setState({ lang: newProps.lang })
        }
    }

    onReloadLinkClick = (e) => {
        window.location.reload()
    }

    render() {       

        var content = []
        var contentBottom = []
        var loader = <div className="hrb-progress-container" style={{ paddingTop: 30 }}>
                         <CircularProgress className="hrb-progress" />
                     </div>
        
        content.push(<div className="error_subtitle_bold" key='errormessage'>{T.translate('Error.SomethingWentWrong')}</div>)      
        if (this.props.lang === 'en') {
            content.push(<div className="error_center_content" key='errorsubtitle'>{T.translate('Error.Message1')}<u><a href="/#" target="_blank" onClick={this.onReloadLinkClick} className="error_content_link">{T.translate('Error.Message2')}</a></u>{T.translate('Error.Message3')}</div>)
            content.push(<div className="error_center_content" key='errorsparkhomelink'><u><a href="/home" className="error_content_link">{T.translate('Error.Message4')}</a></u></div>)
        }
        else {
            content.push(<div className="error_center_content_french" key='errorsubtitle'>{T.translate('Error.Message1')}
                <u>
                    <a onClick={() => window.location.reload()} className="error_content_link">{T.translate('Error.Message2')}</a>
                </u>
                {T.translate('Error.Message3')}
                <u>
                    <a href="/home" className="error_content_link">{T.translate('Error.Message4')}</a>
                </u>
            </div>)
        }

        // todo: improve this by a BUNCH.
        let errorMessage = this.props.error ? (`${this.props.error} ${this.props.errorDetail}`).trim() : T.translate('Error.ErrorCodeMessage')

        contentBottom.push(<div className="error_center_content_bold_small" key='errorsparkblocksubtitle'>{T.translate('Error.StillGetting')}</div>)        
        contentBottom.push(<div className="error_center_content_small" key='errorsparkblocksignal'>{T.translate('Error.StillGettingMessage1')}<u><a className="error_content_link_small" href={T.translate('Error.BlockSignalLink')} target="_blank" rel="noopener noreferrer" >{T.translate('Error.StillGettingMessage2')}</a></u>{T.translate('Error.StillGettingMessage3')}</div>)        
        contentBottom.push(<div className="error_center_content_small" key='errorsparkblockbesure'>{T.translate('Error.BeSureMessage')}</div>)        
        contentBottom.push(<div className="error_center_content_small" key='errorsparkfivehundredmessage'>{errorMessage}</div>)        

        return (
            <div>
                <div style={{ top: '-70px', position: 'relative' }} ><hr style={{ display: 'block', height: '1px', border: '0', borderTop: '1px solid #E4E4E4' }} /></div>
                {this.state.isloading === true ? loader :
                    <div className="logoutOuter">
                        <div className="logoutBox" >
                            <div className="logoutLogoHolder">
                                <HeaderLogo lang={'en'} darkText={true} width={"250px"} />
                            </div>
                            {content}    
                            <hr className="error-hr" />
                            {contentBottom}
                        </div>
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        lang: state.layout.lang,
        error: state.error.error,
        errorDetail: state.error.errorDetail
    }
}

const mapDispatchToProps = (dispatch) => ({
    goBack: () => dispatch(goBack())
})

export default connect(mapStateToProps, mapDispatchToProps)(ErrorPage)